<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-form-field appearance="fill" class="zwi-form-field--medium">
    <mat-label>First and last name</mat-label>
    <input formControlName="speaker" matInput>
    @if (form.get('speaker')?.hasError('required')) {
      <mat-error>Please enter a name</mat-error>
    }
  </mat-form-field>
  <button mat-raised-button color="primary" style="margin-left: 8px;">Add</button>
</form>
<div class="mat-subtitle-2">Speakers</div>
<mat-list>
  @for (speaker of speakers; track speaker) {
    <mat-list-item>
      <mat-icon matListItemIcon>person</mat-icon>
      <span matListItemTitle>{{ speaker.name }}</span>
    </mat-list-item>
  }
</mat-list>
